<template>
	<div class="acc-task-index">
		<div class="fun-btn-box">
			<!-- <auth-button auth="member:point:task:create"> -->
			<el-button type="primary" class="mr10" @click="onAdd">+ 添加周年庆积分任务</el-button>
			<!-- </auth-button> -->
		</div>
		<Table :key="tableKey" :tableThData="tableThData" :tableTrData="tableTrData" :loading="loading" :limit="limit"
			:total="total" :offset="offset" v-on:handleSizeChange="handleSizeChange"
			v-on:handleCurrentChange="handleCurrentChange">
			<template #taskName="{ row }">{{ row.taskName }}</template>
			<template #scene="{ row }">{{ row.scene }}</template>
			<template #description="{ row }">{{ row.description }}</template>
			<template #amount="{ row }">
				<div v-if="!row.isEdit">{{ row.amount }}{{ row.pointType==1 ?'倍':'积分' }}</div>
				<div v-else-if="row.pointType=='1'">
					<el-input class="edit-input" v-model="curInputValue">
						<template slot="append">倍</template>
					</el-input>
				</div>
				<div v-else>
					<el-input class="edit-input" v-model="curInputValue">
						<template slot="append">积分</template>
					</el-input>
				</div>
			</template>
			<template #disable="{ row }">
				<auth-button auth="member:point:task:update" :elseInfo="row.disable ? '关闭' : '开启'">
					<el-switch :value="!row.disable" disabled active-color="#05C8AF" inactive-color="#F2F3F5"
						@click.native="onStatusChange(row)">
					</el-switch>
				</auth-button>
			</template>
			<template #operation="{ scope }">
				<el-button v-if="scope.row.isEdit" type="text" @click="onSave(scope.row, scope.$index)">保存</el-button>
				<auth-button v-else auth="member:point:task:update">
					<el-button type="text" @click="onEdit(scope.row, scope.$index)">编辑</el-button>
				</auth-button>
			</template>
		</Table>

		<!-- 弹窗 签到-->
		<Dialog :maskClose="false" :dialogShow="DialogShow" title="签到规则设置" @maskClick="() => { DialogShow = false }">
			<template>
				<div class="apply">
					<el-form :hide-required-asterisk="true" ref="Form" :model="Form" label-width="150px" :rules="rules"
						style="width: 95%;">
						<el-form-item style="margin-top: 10px;" label="普通签到规则" label-width="100px"
							label-position="left"></el-form-item>
						<el-form-item label="日常签到奖励积分" prop="dailyRule">
							<el-input v-model.number="Form.dailyRule" placeholder="请输入日常签到奖励积分">
								<template slot="append">积分</template>
							</el-input>
						</el-form-item>
						<view>连续签到规则</view>
						<el-form-item label="连续签到设置" label-width="100px" prop="delivery">
							<el-switch v-model="Form.status"></el-switch>
						</el-form-item>
						<div v-if="Form.status">
							<el-form-item label="签到区间" prop="continuityTime">
								<el-date-picker v-model="Form.continuityTime" type="daterange" value-format="timestamp"
									start-placeholder="开始日期" end-placeholder="结束日期" style="width: 100%;"
									:picker-options="pickerOptions">
								</el-date-picker>
							</el-form-item>

							<el-form-item>
								<el-button @click="addRule">添加签到规则</el-button>
							</el-form-item>
							<div style="display: flex;align-items: center;" v-for="(item,index) in Form.continuityRule"
								:key="index">
								<el-form-item label="连续签到" :prop="'continuityRule.' + index + '.day' "
									:rules="{required: true, message: '天数不能为空', trigger: 'blur' }">
									<el-input v-model="item.day"
										oninput="value=value.replace(/^(0+)|[^\d]+/g,'')"><template
											slot="append">天</template>
									</el-input>
								</el-form-item>
								<el-form-item label="奖励" :prop="'continuityRule.' + index + '.point' "
									:rules="{required: true, message: '积分不能为空', trigger: 'blur' }" label-width="50px">
									<el-input v-model="item.point" oninput="value=value.replace(/^(0+)|[^\d]+/g,'')">
										<template slot="append">积分</template>
									</el-input>
								</el-form-item>
								<i class="el-icon-remove-outline" style="margin-bottom: 20px; margin-left:5px"
									@click="reduceRule(index)"></i>
							</div>
						</div>
					</el-form>
					<div class="button-div">
						<el-row class="button-div-row">
							<el-button type="default" class="cancel"
								@click="() => { DialogShow = false }">取消</el-button>
							<el-button type="primary" :loading="DialogLoading" class="determine"
								@click="determine">确定</el-button>
						</el-row>
					</div>
				</div>
			</template>
		</Dialog>

		<!-- 弹窗 会员生日-->
		<Dialog :maskClose="false" :dialogShow="hysr.show" title="会员生日积分规则设置" @maskClick="() => { hysr.show = false }">
			<template>
				<div class="apply">
					<el-form :hide-required-asterisk="true" ref="hysrForm" :model="hysr.form" label-width="150px"
						:rules="rules" style="width: 95%;">
						<el-form-item style="margin-top: 10px;" label="会员生日积分规则" label-width="150px"
							label-position="left"></el-form-item>
						<el-form-item label="任务名称" prop="taskName">
							<el-input type="text" v-model="hysr.form.taskName" placeholder="请输入任务名称" />
						</el-form-item>
						<el-form-item label="奖励积分" prop="amount">
							<el-input v-model.number="hysr.form.amount" placeholder="请输入奖励积分">
								<template slot="append">积分</template>
							</el-input>
						</el-form-item>
						<el-form-item label="券类型" prop="type">
							<el-radio-group v-model="hysr.form.type" @change="onChangeType">
								<el-radio label="coupon">优惠券</el-radio>
								<el-radio label="gift">礼品券</el-radio>
							</el-radio-group>
						</el-form-item>
						<el-form-item v-if="hysr.form.type" :label="hysr.form.type == 'coupon' ? '优惠券' : '礼品券'"
							prop="couponId">

							<el-select v-model="hysr.form.couponId"
								:placeholder="labelPla[(hysr.form.type == 'coupon' ? 0 : 1)]" @change="onPrChange">
								<el-option v-for="item in couponData" :key="item.id" :label="item.name"
									:value="item.id"></el-option>
							</el-select>

						</el-form-item>

						<el-form-item label="说明" prop="description">
							<el-input type="textarea" v-model="hysr.form.description" placeholder="请输入说明" />
						</el-form-item>

					</el-form>
					<div class="button-div">
						<el-row class="button-div-row">
							<el-button type="default" class="cancel" @click="() => { hysr.show = false }">取消</el-button>
							<el-button type="primary" :loading="hysr.loading" class="determine"
								@click="onHysrSubmit">确定</el-button>
						</el-row>
					</div>
				</div>
			</template>
		</Dialog>


		<!-- 弹窗 周年庆-->
		<Dialog :maskClose="false" :dialogShow="znq.show" title="活动积分规则设置" @maskClick="() => { znq.show = false }">
			<template>
				<div class="apply">
					<el-form :hide-required-asterisk="true" ref="znqForm" :model="znq.form" label-width="150px"
						:rules="znq.rules" style="width: 95%;">
						<el-form-item style="margin-top: 10px;" label="活动积分规则" label-width="150px"
							label-position="left"></el-form-item>
						<el-form-item label="任务名称" prop="taskName">
							<el-input type="text" v-model="znq.form.taskName" placeholder="请输入任务名称" />
						</el-form-item>
						<el-form-item label="奖励积分" prop="amount">
							<el-input v-model.number="znq.form.amount" placeholder="请输入奖励积分倍数">
								<template slot="append">倍</template>
							</el-input>
						</el-form-item>
						<el-form-item label="开始日期" prop="startTime">
							<el-date-picker v-model="znq.form.startTime" type="date"
								value-format="yyyy-MM-dd"></el-date-picker>
						</el-form-item>
						<el-form-item label="结束日期" prop="endTime">
							<el-date-picker v-model="znq.form.endTime" type="date"
								value-format="yyyy-MM-dd"></el-date-picker>
						</el-form-item>
						<el-form-item label="说明" prop="description">
							<el-input type="textarea" v-model="znq.form.description" placeholder="请输入说明" />
						</el-form-item>
					</el-form>
					<div class="button-div">
						<el-row class="button-div-row">
							<el-button type="default" class="cancel" @click="() => { znq.show = false }">取消</el-button>
							<el-button type="primary" :loading="znq.loading" class="determine"
								@click="onZnqSubmit">确定</el-button>
						</el-row>
					</div>
				</div>
			</template>
		</Dialog>

	</div>
</template>

<script>
	import AuthButton from '@/components/AuthButton'
	import {
		api_getPointTaskList,
		api_putPointTask,
		api_postCheckInUpdate,
		api_getCheckIn,
		api_getCheckInRuleId
	} from '@/api/integral'
	import {
		api_putTaskEdit,
		api_putTaskAdd
	} from '@/api/accumulationScore'
	import {
		api_getListLabel,
		api_getListPortrait,
		api_getListRTCoupon,
		api_getGiftListCoupon
	} from '@/api/common'
	import tableList from '@/mixins/tableList';
	import Table from "@/components/Table/index";
	import Dialog from "@/components/Dialog/index";

	import moment from 'moment'

	export default {
		name: "accTaskIndex",
		mixins: [tableList],
		components: {
			AuthButton,
			Table,
			Dialog,
		},
		data() {
			return {
				hysr: {
					show: false,
					loading: false,
					row: null,
					rules: {
						amount: [{
							required: true,
							message: '请输入日常奖励积分'
						}],
						couponId: [{
							required: true,
							message: '请选择优惠券'
						}],
					},
					form: {
						typeId: '',
						couponId: ''
					}
				},
				znq: {
					show: false,
					loading: false,
					isNew: false,
					row: null,
					rules: {
						amount: [{
							required: true,
							message: '请输入日常奖励积分'
						}],
						startTime: [{
							required: true,
							message: '请选择开始日期'
						}],
						endTime: [{
							required: true,
							message: '请选择结束日期'
						}],
					},
					form: {

					}
				},
				typeIDLoad: false,
				submitLoading: false,
				tableTrData: [],
				pickerOptions: {
					disabledDate(time) {
						let now = new Date();
						let year = now.getFullYear(); // 年
						let month = now.getMonth() + 1; // 月
						let day = now.getDate(); // 日
						let dates = new Date(year, month, 0).getDate();
						// 时间限制在当天到当月范围之内选择
						return time.getTime() <= new Date(`${year}-${month}-${day-1}`).getTime() || time.getTime() >
							new Date(`${year}-${month}-${dates}`).getTime();
					},
				},
				tableKey: false,
				couponData: [], // 优惠券list数据
				label: ['优惠券', '礼品券', '停车券'],
				labelPla: ['请选择优惠券', '请选择礼品券', '请选择停车券'],
				tableThData: [{
						prop: "taskName",
						label: "任务名称",
						minWidth: "180",
					},
					{
						prop: "scene",
						label: "类型",
						minWidth: "100",
					},
					{
						prop: "description",
						label: "说明",
						minWidth: "200",
					},
					{
						prop: "amount",
						label: "赠送积分",
						minWidth: "180",
					},
					{
						prop: "disable",
						label: "状态",
						minWidth: "180",
					},
					{
						prop: "operation",
						label: "操作",
						minWidth: "150",
					},
				],
				rules: {
					dailyRule: [{
						required: true,
						message: '请输入日常奖励积分'
					}],
					continuityTime: [{
						required: true,
						message: '请输入连续签到时间区间'
					}],
					day: [{
						required: true,
						message: '请输入连续签到天数'
					}],
					point: [{
						required: true,
						message: '请输入奖励积分'
					}],
				},
				curInputValue: '', // 当前编辑项的积分input值
				DialogShow: false,
				DialogShowHD: false,
				DialogShowSR: false,
				DialogLoading: false,
				Form: {
					dailyRule: '',
					status: false,
					continuityTime: [],
					continuityRule: [{
						day: '',
						point: '',
					}]
				},
				form: {
					userTargetType: 'Member',
					grantTime: '0',
					typeId: '1',
					userIds: [],
				},

			};
		},
		created() {

		},
		methods: {
			onPrChange(e) {
				console.log('属性变化了', e)
				this.$forceUpdate()
			},
			// 获取表格列表数据
			async getList() {
				this.loading = true
				const params = {
					offset: this.offset,
					limit: this.limit,
				}
				this.$router.push({
					query: params
				})
				const data = await api_getPointTaskList(params)
				console.log('data: ', data);
				this.tableTrData = data.list || []
				this.total = data.count
				this.loading = false
			},

			// 点击状态切换开关
			async onStatusChange(row) {
				let newRow = JSON.parse(JSON.stringify(row))
				newRow.disable = !row.disable
				this.$baseConfirm(
					row.disable ? '是否开启该积分任务？' : '是否关闭该积分任务？', {
						title: '提示',
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						showClose: false,
						type: 'warning',
					},
					async () => {
						this.updateItem(newRow, () => {
							row.disable = newRow.disable
						})
					}
				)
			},
			//获取签到规则
			async getCheckIn() {
				// 获取签到规则ID
				let res = await api_getCheckInRuleId()
				//通过签到ID获取签到规则
				if (res != 0) {
					this.Form.id = res
					let data = {
						id: res
					}
					let res2 = await api_getCheckIn(data)
					this.Form.dailyRule = res2.dailyRule
					if (res2.status == 1) {
						this.Form.status = true
						this.Form.continuityRule = res2.continuityRule
						this.Form.continuityTime = []
						this.Form.continuityTime.push(res2.continuityStartTime)
						this.Form.continuityTime.push(res2.continuityEndTime)
					}
					console.log(this.Form)
				}

			},
			//选择优惠券类型
			onChangeType() {
				this.typeIDLoad = true //开启等待
				//this.tableTrData = []
				this.hysr.form.couponId = null //清空选择的数据
				console.log(this.hysr.form.type)
				if (this.hysr.form.type == 'coupon') {
					this.getCouponListData() // 获取优惠券列表数据
				} else {
					this.getGiftListCoupon() // 获取礼品券列表数据
				}
			},
			//选择优惠券类型
			setCouponType() {
				this.typeIDLoad = true //开启等待
				//this.tableTrData = []
				//this.hysr.form.couponId = null //清空选择的数据
				console.log(this.hysr.form.type)
				if (this.hysr.form.type == 'coupon') {
					this.getCouponListData() // 获取优惠券列表数据
				} else {
					this.getGiftListCoupon() // 获取礼品券列表数据
				}
			},

			//选择优惠券类型
			handleType() {
				this.typeIDLoad = true //开启等待
				//this.tableTrData = []
				this.form.couponIds = [] //清空选择的数据
				console.log(this.form.typeId)
				if (this.form.typeId == 1) {
					this.getCouponListData() // 获取优惠券列表数据
				} else {
					this.getGiftListCoupon() // 获取礼品券列表数据
				}
			},
			// 券选择改变
			onCouponChange(value) {
				let selectData = []
				this.couponData.forEach(item => {
					if (value.indexOf(item.id) >= 0) {
						selectData.push(item)
					}
				})
				// this.tableTrData = selectData
				// console.log(this.tableTrData)
			},
			// 获取优惠券列表数据
			async getCouponListData() {
				try {
					this.couponData = []
					const res = await api_getListRTCoupon()
					this.typeIDLoad = false
					this.couponData = res
				} catch (error) {
					this.typeIDLoad = false
				}

				this.$forceUpdate()
			},

			// 获取礼品券列表数据
			async getGiftListCoupon() {
				try {
					this.couponData = []
					const res = await api_getGiftListCoupon()
					this.typeIDLoad = false
					this.couponData = res
				} catch (error) {
					this.typeIDLoad = false
				}

				this.$forceUpdate()
			},
			onAdd() {
				this.znq.form = {};
				this.znq.isNew = true;
				this.znq.show = true;
			},
			// 点击编辑按钮
			onEdit(row, index) {
				this.znq.isNew = false;
				let that = this;
				console.log('编辑数据：', row)
				if (row.scene == '签到') {
					this.getCheckIn()
					this.DialogShow = true
				} else if (row.scene == '会员生日') {

					this.hysr.form = row;
					this.hysr.show = true;
					this.setCouponType()

					this.DialogShowSR = true
				} else if (row.scene == '活动') {
					if (!isNaN(row.startTime)) {
						row.startTime = moment(row.startTime).format('yyyy-MM-DD');
					}
					if (!isNaN(row.endTime)) {
						row.endTime = moment(row.endTime).format('yyyy-MM-DD');
					}

					console.log('当前日期：', row)

					this.znq.form = row;
					this.znq.show = true;

				} else {
					this.curInputValue = row.amount
					this.tableTrData.map((item) => {
						item.isEdit = false
					})
					this.tableTrData[index].isEdit = true
					this.tableKey = !this.tableKey
				}
			},

			//添加签到规则
			addRule() {
				this.Form.continuityRule.push({
					day: '',
					point: '',
				})
			},
			//删除签到规则
			reduceRule(index) {
				if (this.Form.continuityRule.length == 1) {
					this.$baseMessage(`最少需添加一条签到规则`, 'error');
					return
				}
				this.Form.continuityRule.splice(index, 1)
			},

			/**
			 * 会员生日保存
			 */
			onHysrSubmit() {
				let that = this;
				this.$refs.hysrForm.validate(async (valid) => {
					if (valid) {
						that.hysr.show = true
						try {
							let form = that.hysr.form;
							var p = {
								amount: form.amount,
								id: form.id,
								scene: 'Birthday',
								couponId: form.couponId,
								taskName: form.taskName,
								pointType:2,
								//typeId: form.typeId,
								type: form.type, //(form.typeId == '0' ? 'gift' : 'coupon'),
								description: form.description
							}

							await api_putTaskEdit(p)

							that.hysr.show = false
							that.$baseMessage('操作成功', 'success')
							that.getList()
						} catch (error) {
							that.hysr.show = false
							console.log('保存失败！', error)
						}
					} else {
						return false
					}
				})
			},

			/**
			 * 周年庆更新确定
			 */
			onZnqSubmit() {
				let that = this;
				console.log('当前表单：', that.znq.form)
				this.$refs.znqForm.validate(async (valid) => {
					if (valid) {
						that.znq.show = true
						try {
							let form = that.znq.form;
							var p = {
								startTime: form.startTime ? (new Date(form.startTime).getTime()) : form
									.startTime,
								endTime: form.endTime ? (new Date(form.endTime + ' 23:59:59').getTime()) :
									form.endTime,
								amount: form.amount,
								scene: 'Anniversary',
								id: form.id,
								pointType:1,
								taskName: form.taskName,
								description: form.description
							}

							if (that.znq.isNew) {
								await api_putTaskAdd(p)
							} else {
								await api_putTaskEdit(p)
							}
							that.znq.show = false
							that.$baseMessage('操作成功', 'success')
							that.getList()
						} catch (error) {
							that.znq.show = false
							console.log('保存失败！', error)
						}
					} else {
						return false
					}
				})
			},
			// 更新确定
			determine() {
				this.$refs.Form.validate(async (valid) => {
					if (valid) {
						this.DialogLoading = true
						try {
							let data = {
								dailyRule: this.Form.dailyRule, //日常奖励积分
								status: this.Form.status ? '1' : '2', // 1开启 2 关闭
							}
							if (data.status == 1) {
								data.continuityStartTime = this.Form.continuityTime[0]
								data.continuityEndTime = this.Form.continuityTime[1]
								data.continuityRule = this.Form.continuityRule
							}
							if (this.Form.id) {
								data.id = this.Form.id
							}
							console.log(data)
							await api_postCheckInUpdate({
								...data
							})
							this.DialogLoading = false
							this.DialogShow = false
							this.$baseMessage('操作成功', 'success')
							this.getList()
						} catch (error) {
							this.DialogLoading = false
						}
					} else {
						return false
					}
				})
			},

			// 点击保存按钮
			onSave(row, index) {
				let newRow = row
				newRow.amount = this.curInputValue
				this.updateItem(newRow, () => {
					this.curInputValue = ''
					this.tableTrData[index].isEdit = false
					this.tableKey = !this.tableKey
				})
			},
			// 更新数据
			async updateItem(row, cb) {
				let {
					id,
					tenantId,
					amount,
					disable
				} = row
				await api_putPointTask({
					id,
					tenantId,
					amount,
					disable
				})
				this.$baseMessage('操作成功', 'success')
				cb()
			}
		},
		watch: {},
		computed: {},
	};
</script>

<style>
	.Dialog .content {
		width: 40% !important;
	}
</style>

<style lang="scss" scoped>
	.apply {
		min-height: 170px;
		max-height: 500px;
		overflow-y: auto;
		overflow-x: hidden;
	}

	.button-div {
		overflow: hidden;
		float: right;
		margin-top: 33px;

		button {
			border: 0;
			width: 110px;
			height: 40px;
			border-radius: 2px;
			font-size: 16px;
		}

		.cancel {
			background: #F2F3F5;
			color: #666666;
		}
	}

	.acc-task-index {
		width: 100%;
		padding: 15px 20px;
		box-sizing: border-box;

		.edit-input {
			width: 200px;
		}

		::v-deep {

			// 去除switch禁用 css
			.el-switch.is-disabled {
				opacity: 1;
			}

			.el-switch.is-disabled .el-switch__core,
			.el-switch.is-disabled .el-switch__label {
				cursor: pointer;
			}
		}
	}
</style>